import { Fragment } from "react";
import { TruncateList } from "widgets";

import css from "../styles/Cell.module.css";

interface TruncateListTextProps {
  items: readonly string[];
  separator?: string;
  ellipsis?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function TruncateListText({
  items,
  separator = ", ",
  ellipsis = "…",
  className = "",
  style,
  ...props
}: TruncateListTextProps & React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <TruncateList
      items={items}
      getLabel={(item) => item}
      separator={separator}
      ellipsis={ellipsis}
      className={className}
      style={style}
      {...props}
    >
      {({ hiddenCount, resultText, separator: computedSeparator, suffixText, visibleLabels }) => {
        if (visibleLabels.length === 0) {
          return resultText;
        }

        return (
          <>
            {visibleLabels.map((label, index) => (
              <Fragment key={`${label}-${index}`}>
                {label}
                {index < visibleLabels.length - 1 && computedSeparator}
              </Fragment>
            ))}
            {hiddenCount > 0 && <span className={css.affix}>{suffixText}</span>}
          </>
        );
      }}
    </TruncateList>
  );
}
